/**
 * Every element name a browser parses as a real tag: HTML (current and
 * obsolete, plus new ones browsers ship such as `fencedframe`,
 * `selectedcontent` and `permission`), SVG and MathML. Lower case. SVG's
 * camelCase names (`foreignObject`, `clipPath`) are matched case-insensitively.
 *
 * NPJB-838: `sanitizeInput` strips only these. A `<` before any other word
 * (`x<y and y>z`, `size<Enterprise > SMB`) is plain text and stays as typed.
 */
const HTML_TAGS = `
  a abbr acronym address applet area article aside audio b base basefont bdi bdo bgsound big
  blink blockquote body br button canvas caption center cite code col colgroup content data
  datalist dd del details dfn dialog dir div dl dt element em embed fencedframe fieldset
  figcaption figure font footer form frame frameset geolocation h1 h2 h3 h4 h5 h6 head header
  hgroup hr html i iframe image img input ins isindex kbd keygen label legend li link listing
  main map mark marquee menu menuitem meta meter model multicol nav nextid nobr noembed noframes
  noscript object ol optgroup option output p param permission picture plaintext portal pre
  progress q rb rp rt rtc ruby s samp script search section select selectedcontent shadow slot
  small source spacer span strike strong style sub summary sup table tbody td template textarea
  tfoot th thead time title tr track tt u ul usermedia var video wbr xmp
`;

const SVG_TAGS = `
  altglyph altglyphdef altglyphitem animate animatecolor animatemotion animatetransform circle
  clippath cursor defs desc discard ellipse font-face font-face-format font-face-name
  font-face-src font-face-uri hatch hatchpath mesh meshgradient meshpatch meshrow missing-glyph
  solidcolor feblend fecolormatrix fecomponenttransfer fecomposite feconvolvematrix
  fediffuselighting fedisplacementmap fedistantlight fedropshadow feflood fefunca fefuncb
  fefuncg fefuncr fegaussianblur feimage femerge femergenode femorphology feoffset fepointlight
  fespecularlighting fespotlight fetile feturbulence filter foreignobject g glyph glyphref hkern
  line lineargradient marker mask metadata mpath path pattern polygon polyline radialgradient
  rect set stop svg switch symbol text textpath tref tspan use view vkern
`;

const MATHML_TAGS = `
  annotation annotation-xml maction maligngroup malignmark math menclose merror mfenced mfrac
  mglyph mi mlabeledtr mlongdiv mscarries mscarry msgroup msline msrow mstack mmultiscripts mn
  mo mover mpadded mphantom mprescripts mroot mrow ms mspace msqrt mstyle msub msubsup msup
  mtable mtd mtext mtr munder munderover none semantics
`;

export const HTML_TAG_NAMES: ReadonlySet<string> = new Set(
  [HTML_TAGS, SVG_TAGS, MATHML_TAGS].join(' ').trim().split(/\s+/),
);
